import { ANALYTICS } from "analytics";
import requestIdleCallback from "./requestIdleCallback";
import { ApiClient } from "@kubera/common";

let appLoadTimeStart = 0;
let appLoadTimeEnd = 0;

export const KAEvent = param => {
  if (!param?.n) {
    return;
  }
  param.t = Math.floor(Date.now() / 1000);
  param.o = new Date().getTimezoneOffset();
  requestIdleCallback(() => {
    ApiClient.captureAnalytics(param).catch(apiError => {
      console.log("KAEvent error:", apiError, "param", param);
    });
  });
};

export const KAAppLoadTime = (context, type) => {
  if (type === "start") {
    appLoadTimeStart = Date.now();
    console.log(`ALT[${context}-${type}] - ${appLoadTimeStart}`);
    return;
  }

  if (type === "ignore") {
    appLoadTimeStart = Date.now();
    appLoadTimeEnd = Date.now();
    console.log(`ALT[${context}-${type}] - ${appLoadTimeStart}/${appLoadTimeEnd}`);
    return;
  }

  if (type !== "end") {
    console.log(`ALT[${context}-${type}] - ignored, invalid type`);
    return;
  }

  if (appLoadTimeEnd) {
    console.log(`ALT[${context}-${type}] - ignored, repeated call`);
    return;
  }

  appLoadTimeEnd = Date.now();

  if (!appLoadTimeStart) {
    console.log(`ALT[${context}-${type}] - ignored, invalid appLoadTimeStart - ${appLoadTimeStart}`);
    return;
  }

  // report app load time
  const appLoadTime = Math.round(appLoadTimeEnd - appLoadTimeStart);
  const action = `${ANALYTICS.ACTION.APP_LOADED}`;
  console.log(`ALT[${context}-${type}] Added: ${action}, appLoadTime: ${appLoadTime}`);

  const param = {
    n: action,
    extra: appLoadTime
  };
  KAEvent(param);
};
